'use client';

import type { InteractionType } from '~/model/InteractionType';
import { VpIcon } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { checkIfInteractionIsComing } from '@/app/utils/entities/interactions';

export const InteractionNotActive = ({ interaction }: { interaction: InteractionType }) => {
  const t = useTranslations('INTERACTION');
  const translationKey = checkIfInteractionIsComing(interaction) ? 'IS_COMING' : 'FINISHED';

  return (
    <section className="centered-box">
      <div className="centered-box__content">
        <VpIcon name="timer" />
        {' '}
        {t(translationKey)}
      </div>
    </section>
  );
};
